// extracted by extract-css-chunks-webpack-plugin
module.exports = {"site-copyright":"site-copyright_VGtoE","site-copyright_inverted":"site-copyright_inverted_3HU0-"};